<div class="flex-note" *ngIf="terminiOrNote()">
    <div class="note" *ngIf="note && note.length > 1" (click)="showPopUp(1)">
        Note cantina
    </div>
    <div class="notebase-show" [ngClass]="showNote ? 'opened':'closed'">
        <div class="d-flex top-title">
            <div class="title-show">Note cantina</div>
            <div class="close material-symbols-outlined" (click)="showNote=false">close</div>
        </div>
        <div [innerHTML]="note" class="note-description"></div>
    </div>

    <div class="note" *ngIf="termini && termini.length > 1" (click)="showPopUp(2)">
        Termini cancellazione
    </div>
    <div class="notebase-show" [ngClass]="showTermini ? 'opened':'closed'">
        <div class="d-flex top-title">
            <div class="title-show">Termini cancellazione</div>
            <div class="close material-symbols-outlined" (click)="showTermini=false">close</div>
        </div>
        <div [innerHTML]="termini" class="note-description"></div>
    </div>
</div>